
import React, { Component } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import dayjs from 'dayjs';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import Button from '@mui/material/Button';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import logoImage from './images/logo.jpg';
import psdfimage from './images/psdfimage.png';


function withRouter(Component) {
  return function WrappedComponent(props) {
    const location = useLocation();
    return <Component {...props} location={location} />;
  };
}
class TransactionReport extends Component {
  constructor(props) {
    super(props);
    const searchParams = new URLSearchParams(this.props.location.search);
    const ledgerId = searchParams.get('ledger_id');
    const fromDate = searchParams.get('from');
    const toDate = searchParams.get('to');
    const currentDate = new Date();
    this.state = {
      ledger_id: ledgerId || '',
      fromdate: fromDate ? dayjs(fromDate) : dayjs(currentDate).startOf('month'),
      todate: toDate ? dayjs(toDate) : dayjs(currentDate).endOf('month'),
      fromdate1: fromDate || dayjs(currentDate).startOf('month').format('YYYY-MM-DD'),
      todate1: toDate || dayjs(currentDate).endOf('month').format('YYYY-MM-DD'),
      fromDateEnabled: false,
      toDateEnabled: false,
      ReportData: [],
      page: 0,
      rowsPerPage: 50,
      totaldata: 0,
      ledgerName: '',
       openExportDialog: false,totalAmount:'',processedData:[],
    };
  }
  componentDidMount() {
    if (this.state.ledger_id) {
      this.loadLedgerName();
    }
    this.apicall();
  }
loadLedgerName = () => {
  axios.get(
    localStorage.getItem("ISIurl") + 'ajaxledger.php?action=getall'
  )
    .then(resp => {
      if (resp.data && resp.data.length > 0) {
        const ledger = resp.data.find(
          l => l.le_code == this.state.ledger_id   
        );
        if (ledger) {
          this.setState({
            ledgerName: `${ledger.le_code} - ${ledger.le_ledgername}`
          });
        }
      }
    });
};
  apicall = () => {
    const url =
      localStorage.getItem("ISIurl") +
      'ajaxsalesunionreport.php?action=salesreportbyledgercode' +
      '&from_date=' + this.state.fromdate1 +
      '&to_date=' + this.state.todate1 +
      '&le_code=' + (this.state.ledger_id || "")+'&cmp_id='+localStorage.getItem('ISIcmpid');
    axios.get(url)
      .then(resp => {
        let data = Array.isArray(resp.data) ? resp.data : [];
        this.setState({
          ReportData: data,
          totaldata: data.length
        });
      })
      .catch(err => console.error(err));
  };
   handleOpenExportDialog = () => {
    this.setState({ openExportDialog: true });
  };
  handleCloseExportDialog = () => {
    this.setState({ openExportDialog: false });
  };
handleDownloadPDF = () => {
  const { ledgerName, fromdate, todate, ReportData } = this.state;
  
   let runningTotal = 0;
  const processedData = ReportData.map(item => {
    const amt = parseFloat(item.amount) || 0;
    runningTotal += amt;
    return {
      ...item,
      balance: runningTotal
    };
  });
  
  const totalAmount = processedData.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);
  
  const doc = new jsPDF();
  doc.setFontSize(16);
  doc.text("Transaction Report", doc.internal.pageSize.width / 2, 22, { align: "center" });
  doc.setFontSize(10);
  doc.text(`Ledger: ${ledgerName || ''}`, doc.internal.pageSize.width / 2, 30, { align: "center" });
  doc.text(
    `From: ${fromdate.format('DD/MM/YYYY')} To: ${todate.format('DD/MM/YYYY')}`,
    doc.internal.pageSize.width / 2, 36, { align: "center" }
  );
  
  const body = processedData.map(item => ([
    item.date || '',
    item.type || 'Bill',
    item.number || '',
    item.name || '',
    item.description || '',
    item.ledger_name || '',
    parseFloat(item.amount || 0).toFixed(2),
    item.balance ? item.balance.toFixed(2) : ''
  ]));
  
  doc.autoTable({
    startY: 45,
    head: [["Date", "Transaction Type", "Ref", "Name", "Memo/Description", "Ledger Name", "Amount", "Balance"]],
    body,
    foot: [["", "", "", "", "", "Total", totalAmount.toFixed(2), runningTotal.toFixed(2)]],
    styles: { fontSize: 8 },
    headStyles: { fillColor: [21, 101, 192] }
  });
  
  doc.save("TransactionReport.pdf");
};   fromdatehandler = (date) => {
    this.setState({
      fromdate: dayjs(date),
      fromdate1: dayjs(date).format('YYYY-MM-DD')
    }, this.apicall);
  };
  todatehandler = (date) => {
    this.setState({
      todate: dayjs(date),
      todate1: dayjs(date).format('YYYY-MM-DD')
    }, this.apicall);
  };
  render() {
    const { ReportData, ledgerName, fromdate, todate } = this.state;
 let runningTotal = 0;

const processedData = ReportData.map(item => {
  const amt = parseFloat(item.amount) || 0;
  runningTotal += amt;

  return {
    ...item,
    balance: runningTotal
  };
});

 const totalAmount = processedData.reduce((sum, item) => {
  return sum + (parseFloat(item.amount) || 0);
}, 0);

const closingBalance = runningTotal;
    return (
      <div>
         <div style={{ padding: "10px 15px" }}>
          {ledgerName && (
            <div style={{
              fontSize:"17px",
              padding: "10px",
              marginTop: "10px",
              fontWeight: "bold",background:"#c7c7c7"
            }}>
              Ledger: {ledgerName}
            </div>
          )}
        </div>
         <div style={{ alignItems:"center",display: "flex", gap: 10, padding: "10px 15px" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              value={this.state.fromdate}
              onChange={this.fromdatehandler}
              format="DD/MM/YYYY"
			  disabled={true}
            />
          </LocalizationProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              value={this.state.todate}
              onChange={this.todatehandler}
              format="DD/MM/YYYY"
			  disabled={true}
            />
          </LocalizationProvider>
          <Button
  variant="contained"
  className="frmPrimarybtn"
  onClick={this.handleOpenExportDialog}
  sx={{ height: 35 }}  
>
  EXPORT
</Button>
        </div>
         <TableContainer>
          <Table id="transactionreport" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Transaction Type</TableCell>
                <TableCell>Ref</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Memo/Description</TableCell>
                <TableCell>Ledger Name</TableCell>
                <TableCell align="right">Amount</TableCell>
                <TableCell align="right">Balance</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {processedData.map((item, index) => {
  let strlink = "";

  if (item.type === "Sales Invoice") {
    strlink = `#/Salesinvoiceviewmore?sinoid=${item.id}`;
  } else if (item.type === "Sales Credit Note") {
    strlink = `#/Salecreditnoteviewmore?scnoid=${item.id}`;
  } else if (item.type === "Vendor Bill") {
    strlink = `#/vendorbillviewmore?vbid=${item.id}`;
  } else if (item.type === "Vendor Credit Note") {
    strlink = `#/Vendorcreditnoteviewmore?vcnid=${item.id}`;
  } else if (item.type === "Bill") {
    strlink = `#/Journalviewmore?joid=${item.id}`;
  }

  return (
    <TableRow
      key={index}
      hover
      style={{ cursor: strlink ? "pointer" : "default" }}
      onClick={() => {
        if (strlink) {
          window.location.href = strlink;
        }
      }}
    >
      <TableCell>{dayjs(item.date).format("MM/DD/YYYY")}</TableCell>
      <TableCell>{item.type || "Bill"}</TableCell>
      <TableCell>{item.number}</TableCell>
      <TableCell>{item.name}</TableCell>
      <TableCell>{item.description}</TableCell>
      <TableCell>{item.ledger_name}</TableCell>
      <TableCell align="right">{'\u200B' + parseFloat(item.amount || 0).toFixed(2)}</TableCell>
      <TableCell align="right">{'\u200B' + parseFloat(item.balance || 0).toFixed(2)}</TableCell>
    </TableRow>
  );
})}
<TableRow>
  <TableCell colSpan={6} align="right" style={{ fontWeight: 'bold' }}>
    Total
  </TableCell>
  <TableCell align="right" style={{ fontWeight: 'bold' }}>
    {'\u200B' + totalAmount.toFixed(2)}
  </TableCell>
  <TableCell align="right" style={{ fontWeight: 'bold' }}>
   {'\u200B' + closingBalance.toFixed(2)}
  </TableCell>
</TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <Dialog open={this.state.openExportDialog} onClose={this.handleCloseExportDialog}>
    <DialogTitle>Transaction Report</DialogTitle>

    <DialogContent>
        <p>
            To generate a new report, based on the latest selection criteria 
            you've specified, choose the format you want to use. Depending on 
            the amount of data included on the report, it may take some time 
            to generate.
        </p>

        <p style={{ 
            textAlign: "center", 
            display: "flex", 
            justifyContent: "center", 
            gap: "20px" 
        }}>

            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                className="my-custom-excel-button"
                table="transactionreport"
                filename="Transaction_Report"
                sheet="Transaction Report"
                buttonText=""
            />

            <img
                src={psdfimage}
                width={100}
                height={100}
                style={{ cursor: "pointer" }}
                onClick={this.handleDownloadPDF}
                alt="Download PDF"
            />

        </p>

    </DialogContent>

    <DialogActions>
        <Button 
            onClick={this.handleCloseExportDialog} 
            color="primary"
        >
            Cancel
        </Button>
    </DialogActions>

</Dialog>
      </div>
    );
  }
}
export default withRouter(TransactionReport);